import { css } from '@emotion/react';
import { widgetStyles } from '@sitebuilder/common';

const theme = widgetStyles.variables;
const themeEditorStyles = css`
    width: 100%;
    height: 100vh;
    font-size: 14px;
    transition:
        margin 500ms,
        width 0.5s ease-in-out;
    overflow: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;

    .pane-header {
        position: fixed;
        top: 0;
        right: 12px;
        height: 68px;
        z-index: 1000;
        padding: 10px 0 8px 10.5px;
    }

    .toolbar {
        display: flex;
        align-items: center;
        width: 150px;
        border-radius: 24px;
        margin-left: 6px;
        box-shadow: 0 3px 6px 0 #00000029;
        background-color: #fff;
        height: 48px;
        justify-content: center;
    }

    .toolbar-button {
        width: 93px;
        height: 29px;
        margin: 10px 16px;
        padding: 6px 20px;
        border-radius: 14.5px !important;
        border: 1px solid #2c2e32 !important;
        background-color: #fff;
        font-family: ${theme['$font-family-regular']} !important;
        font-size: ${theme['$font-size-x-small']} !important;
        font-weight: 600;
        color: #2c2e32;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
            width: 16px;
            height: 16px;
            margin: 0 8px 0 0;
            object-fit: contain;
        }
    }
`;

export default themeEditorStyles;
